import { createAction, props } from '@ngrx/store';

import { Study } from 'src/app/models/study';
import { AuthErrorResponse } from 'src/app/models/auth-error-response';
import { UmResearcher } from 'src/app/models/um-researcher';

export const getResearcherStudies = createAction(
  '[User Management Studies] Get Researcher Studies',
  props<{ researcherId: number }>()
);

export const getResearcherStudiesSuccess = createAction(
  '[User Management Studies] Get Researcher Studies Success',
  props<{ studies: Study[] }>()
);

export const getResearcherStudiesError = createAction(
  '[User Management Studies] Get Researcher Studies Error',
  props<{ err: AuthErrorResponse }>()
);

export const changeUmResearcherStudyAccess = createAction(
  '[User Management Studies] Change Researcher Study Access',
  props<{ researcher: UmResearcher; study: Study; block: boolean }>()
);

export const changeUmResearcherStudyAccessSuccess = createAction(
  '[User Management Studies] Change Researcher Study Access Success',
  props<{ changedStudy: Study }>()
);

export const changeUmResearcherStudyAccessError = createAction(
  '[User Management Studies] Change Researcher Study Access Error'
);

export const deleteStudy = createAction('[User Management Studies] Delete Study', props<{ study: Study }>());

export const deleteStudySuccess = createAction(
  '[User Management Studies] Delete Study Success',
  props<{ deletedStudy: Study }>()
);

export const deleteStudyError = createAction('[User Management Studies] Delete Study Error');
